module.exports = __webpack_public_path__ + "img/integra-eventos.2b6778e2.jpg";